import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative border-r border-white/[0.06] p-12 bg-[#070707] overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
        <Link to="/" className="relative inline-flex items-center gap-3">
          <div className="w-7 h-7 border border-primary grid place-items-center primary-glow"><span className="font-heading font-black text-primary text-sm">D</span></div>
          <div><div className="font-heading font-bold text-sm">DW Mortgage Hub</div><div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground font-mono">Console</div></div>
        </Link>
        <div className="relative mt-24 max-w-md">
          <div className="text-[10px] font-mono uppercase tracking-[0.28em] text-muted-foreground">Signed handoff</div>
          <div className="mt-4 font-heading font-black text-5xl tracking-tighter leading-[0.95]">Every social touch, structured & piped to intake.</div>
          <p className="mt-6 text-sm text-muted-foreground">Log in to access Agent A, Agent B and your Social Leads pipeline.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <Link to="/" className="lg:hidden inline-flex items-center gap-3 mb-8">
            <div className="w-7 h-7 border border-primary grid place-items-center"><span className="font-heading font-black text-primary text-sm">D</span></div>
            <div className="font-heading font-bold text-sm">DW Mortgage Hub</div>
          </Link>
          <div className="text-[10px] font-mono uppercase tracking-[0.28em] text-muted-foreground">Sign in</div>
          <h1 className="mt-3 font-heading font-black text-4xl tracking-tighter">Welcome back.</h1>
          <p className="mt-2 text-sm text-muted-foreground">Access your DW Mortgage Hub console.</p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="block text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-2">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@lender.co" className="w-full bg-transparent border border-white/10 focus:border-primary/50 outline-none px-4 py-3 rounded-sm text-sm" />
            </div>
            <div>
              <label className="block text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-2">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full bg-transparent border border-white/10 focus:border-primary/50 outline-none px-4 py-3 rounded-sm text-sm" />
            </div>
          </div>

          <button type="submit" disabled={loading} data-testid="login-submit" className="mt-8 w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-primary text-primary-foreground rounded-sm font-medium primary-glow hover-lift disabled:opacity-60">
            {loading ? "Signing in…" : (<>Enter console <ArrowRight size={16} weight="bold" /></>)}
          </button>

          <div className="mt-6 text-sm text-muted-foreground text-center">
            No account?{" "}
            <Link to="/register" data-testid="login-register-link" className="text-primary hover:opacity-80">Request access</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
